import { imageUrl } from "@/config/apiUrl";
import { cn, getUserName } from "@/helper/HelperFunction";
import { signOutRequest } from "@/store/auth/authSlice";
import { TbChevronDown } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PopperComponent from "../Core/PopperComponent";
import classes from "./ProfileComponent.module.css";
import { useMediaQuery } from "@/customHooks/useMediaQuery";

const ProfileDetailsComponent = () => {
  const { user } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const handleLogout = () => {
    dispatch(signOutRequest());
    navigate("/login");
  };

  const handleRedirect = (e) => {
    switch (e?.value) {
      case "logout":
        handleLogout();
        break;
      case "settings":
        navigate("/profile-settings");
        break;
      default:
        navigate("/");
        break;
    }
  };
  return (
    <div className={cn(classes.profileMain)}>
      <PopperComponent
        sideOffset={10}
        data={
          !isMobile
            ? [{ label: "Logout", value: "logout" }]
            : [
                { label: "Settings", value: "settings" },
                { label: "Logout", value: "logout" },
              ]
        }
        asChild
        side={"top"}
        align={"end"}
        handleClick={handleRedirect}
      >
        <div className={classes.profileContainer}>
          <div
            className={cn(
              classes.imageWrapper,
              classes.circular,
              !user?.photo && classes.iconBg
            )}
          >
            <img
              src={imageUrl(user?.photo)}
              alt={getUserName(user) || "--"}
              width={50}
              height={50}
              className={classes.profileImage}
            />
          </div>
          <div className={classes.profileDetails}>
            <p>{getUserName(user) || "--"}</p>
          </div>
          <TbChevronDown size={18} color="var(--text-color)" />
        </div>
      </PopperComponent>
    </div>
  );
};

export default ProfileDetailsComponent;
